/* Polly floating chat launcher.
 *
 *   <script src="https://<polly>/embed.js" data-bot="<agent_id>" defer></script>
 *
 * Optional: data-color="#4883c4" (launcher + chat accent) data-position="left|right" data-offset-bottom="24"
 *           data-offset-side="24" data-label="Chat with us" data-host="https://<polly>"
 *           data-cart="shopify" data-customer-name="…" data-customer-email="…" data-background="linear-gradient(174deg,#4883c4,#abc8e9)"
 *           (data-host is needed only when this file is self-hosted; data-cart="shopify" lets the
 *           bot see the visitor's cart: after the chat is opened, this script reads the shop's own
 *           /cart.js and passes a summary to the chat before each message).
 *
 * Privacy: until the visitor clicks the bubble this script makes no requests and touches
 * no cookies or storage; the chat iframe (and everything it loads) is created on click.
 *
 * Positioning is overridable from the host page's CSS:
 *   --polly-bottom, --polly-side (bubble offsets), --polly-z (stacking, default 2147482000)
 * on :root or on #polly-launcher / #polly-panel.
 *
 * data-customer-name / data-customer-email: the shop's logged-in customer (e.g. from Shopify's
 * {% if customer %} Liquid). Passed to the chat only once it's opened; a label, not proof of identity.
 * data-background: optional launcher background (a hex colour or a simple linear-gradient).
 *
 * Host-page events (window):
 *   "polly:add_to_cart"  CustomEvent, detail {variant_id, quantity, request_id, respond(result)}
 *                        Answer with detail.respond({ok, message}) or by dispatching
 *                        "polly:cart_result" (detail {request_id, ok, message}) on window.
 *   "polly:open" / "polly:close"  CustomEvents fired when the panel opens / closes.
 *   "polly:open_cart"   cancelable CustomEvent from the chat's "View cart"; call preventDefault()
 *                       and open your cart drawer, or let it fall through to /cart.
 * API: window.Polly.open(), .close(), .toggle()
 */
(function () {
  var me = document.currentScript;
  if (!me || window.Polly) return;
  var bot = me.getAttribute('data-bot') || '';
  if (!/^[A-Za-z0-9_-]{1,64}$/.test(bot)) return;
  var host, origin;
  try { host = new URL(me.getAttribute('data-host') || me.src, location.href); origin = host.origin; } catch (e) { return; }
  var color = me.getAttribute('data-color') || '#171717';
  if (!/^#[0-9a-fA-F]{3,8}$/.test(color)) color = '#171717';
  var bg = me.getAttribute('data-background') || '';
  if (!/^(#[0-9a-fA-F]{3,8}|linear-gradient\(\d{1,3}deg(\s*,\s*#[0-9a-fA-F]{3,6}(\s+\d{1,3}%)?){2,4}\))$/.test(bg)) bg = color;
  var side = me.getAttribute('data-position') === 'left' ? 'left' : 'right';
  function px(name, dflt) { var n = parseInt(me.getAttribute(name), 10); return (n >= 0 && n < 2000 ? n : dflt) + 'px'; }
  var B = px('data-offset-bottom', 24), S = px('data-offset-side', 24);
  var label = (me.getAttribute('data-label') || 'Chat with us').slice(0, 60);
  var shopifyCart = me.getAttribute('data-cart') === 'shopify';
  var customer = { name: (me.getAttribute('data-customer-name') || '').trim().slice(0, 80),
                   email: (me.getAttribute('data-customer-email') || '').trim().slice(0, 120) };
  if (!customer.name && !customer.email) customer = null;

  var css =
    '#polly-launcher,#polly-panel{--pb:var(--polly-bottom,' + B + ');--ps:var(--polly-side,' + S + ');z-index:var(--polly-z,2147482000)}' +
    '#polly-launcher{position:fixed;' + side + ':var(--ps);bottom:var(--pb);width:56px;height:56px;border-radius:50%;border:0;padding:0;margin:0;cursor:pointer;' +
    'background:' + bg + ';color:#fff;box-shadow:0 6px 18px rgba(16,24,40,.22);display:flex;align-items:center;justify-content:center;transition:transform .15s ease}' +
    '#polly-launcher:hover{transform:scale(1.05)}#polly-launcher:focus-visible{outline:3px solid ' + color + ';outline-offset:3px}' +
    '#polly-launcher svg{display:block}#polly-launcher .pl-c{width:30px;height:30px}#polly-launcher .pl-x{width:24px;height:24px;display:none}' +
    '#polly-launcher[aria-expanded="true"] .pl-c{display:none}#polly-launcher[aria-expanded="true"] .pl-x{display:block}' +
    '#polly-panel{position:fixed;' + side + ':var(--ps);bottom:calc(var(--pb) + 68px);width:380px;height:600px;' +
    'max-width:calc(100vw - 32px);max-height:calc(100vh - var(--pb) - 88px);border-radius:14px;overflow:hidden;background:#fff;' +
    'box-shadow:0 12px 40px rgba(0,0,0,.22);display:none}' +
    '#polly-panel.open{display:block;animation:polly-in .18s ease-out}#polly-panel iframe{width:100%;height:100%;border:0;display:block}' +
    '@keyframes polly-in{from{opacity:0;transform:translateY(8px) scale(.985)}to{opacity:1;transform:none}}' +
    '@media (prefers-reduced-motion:reduce){#polly-panel.open{animation:none}#polly-launcher{transition:none}}' +
    '@media (max-width:480px){#polly-panel{inset:0;width:100%;height:100%;max-width:none;max-height:none;border-radius:0}' +
    '#polly-panel.open+#polly-launcher,#polly-launcher[aria-expanded="true"]{display:none}}';
  var st = document.createElement('style');
  st.textContent = css;
  document.head.appendChild(st);

  var btn = document.createElement('button');
  btn.id = 'polly-launcher';
  btn.className = 'polly-launcher';
  btn.type = 'button';
  btn.setAttribute('aria-label', label);
  btn.setAttribute('aria-expanded', 'false');
  btn.setAttribute('aria-controls', 'polly-panel');
  btn.innerHTML =
    '<svg class="pl-c" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.1" stroke-linejoin="round" stroke-linecap="round" aria-hidden="true"><path d="M4.75 15.14L3.05 20.95L8.86 19.25A8.5 8.5 0 1 0 4.75 15.14Z"/></svg>' +
    '<svg class="pl-x" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2.2" stroke-linecap="round" aria-hidden="true"><path d="M6 6l12 12M18 6L6 18"/></svg>';

  var panel = null, frame = null, isOpen = false, pending = {};

  function toFrame(msg) { if (frame && frame.contentWindow) frame.contentWindow.postMessage(msg, origin); }
  function pageUrl() { return location.href.split('#')[0].slice(0, 1000); }

  function build() {
    panel = document.createElement('div');
    panel.id = 'polly-panel';
    panel.className = 'polly-panel';
    panel.setAttribute('role', 'dialog');
    panel.setAttribute('aria-label', label);
    frame = document.createElement('iframe');
    frame.title = label;
    frame.src = origin + '/chat/' + encodeURIComponent(bot) + '?embed=1&color=' + encodeURIComponent(color);
    panel.appendChild(frame);
    btn.parentNode.insertBefore(panel, btn);   // panel precedes the button (mobile CSS sibling rule)
    window.addEventListener('message', onMessage);
  }

  function open() {
    if (!panel) build();
    isOpen = true;
    panel.classList.add('open');
    btn.setAttribute('aria-expanded', 'true');
    try { frame.focus(); } catch (e) {}
    toFrame({ type: 'polly:focus' });
    window.dispatchEvent(new CustomEvent('polly:open'));
  }
  function close() {
    if (!isOpen) return;
    isOpen = false;
    panel.classList.remove('open');
    btn.setAttribute('aria-expanded', 'false');
    btn.focus();
    window.dispatchEvent(new CustomEvent('polly:close'));
  }
  function toggle() { isOpen ? close() : open(); }

  function cartResult(rid, r) {
    if (!pending[rid]) return;
    delete pending[rid];
    r = r || {};
    toFrame({ type: 'polly:cart_result', request_id: rid, ok: !!r.ok,
              message: typeof r.message === 'string' ? r.message.slice(0, 40) : '' });
    setTimeout(sendCart, 300);
  }

  // Shopify cart summary for the chat (only with data-cart="shopify", only once the chat exists).
  function sendCart() {
    if (!shopifyCart || !frame) return;
    fetch('/cart.js', { credentials: 'same-origin', cache: 'no-store', headers: { Accept: 'application/json' } })
      .then(function (r) { return r.ok ? r.json() : null; })
      .then(function (c) {
        if (!c) return;
        toFrame({ type: 'polly:cart', cart: {
          count: c.item_count || 0, total: c.total_price || 0, currency: c.currency || '',
          items: (c.items || []).slice(0, 30).map(function (i) {
            var v = i.variant_title && i.variant_title !== 'Default Title' ? ' (' + i.variant_title + ')' : '';
            return { title: String(i.product_title || i.title || '') + v, quantity: i.quantity, variant_id: String(i.variant_id || '') };
          }) } });
      })
      .catch(function () {});
  }

  function onMessage(e) {
    if (e.origin !== origin || !frame || e.source !== frame.contentWindow) return;
    var d = e.data || {};
    if (d.type === 'polly:ready') {
      toFrame({ type: 'polly:init', page_url: pageUrl(), cart: shopifyCart, customer: customer });
      sendCart();
      if (isOpen) toFrame({ type: 'polly:focus' });
    } else if (d.type === 'polly:open_cart') {
      // "View cart" in the chat: the theme can open its cart drawer (preventDefault on the event);
      // otherwise go to the shop's cart page.
      var ev = new CustomEvent('polly:open_cart', { cancelable: true });
      if (window.dispatchEvent(ev)) location.href = '/cart';
    } else if (d.type === 'polly:cart_sync') {
      sendCart();
    } else if (d.type === 'polly:close') {
      close();
    } else if (d.type === 'polly:navigate') {
      var u;
      try { u = new URL(String(d.url), location.href); } catch (err) { return; }
      if (!/^https?:$/.test(u.protocol)) return;
      if (u.origin === location.origin) location.href = u.href;
      else window.open(u.href, '_blank', 'noopener');
    } else if (d.type === 'polly:add_to_cart') {
      var vid = Number(d.variant_id), rid = String(d.request_id || '').slice(0, 32);
      if (!(vid > 0) || !rid) return;
      pending[rid] = true;
      var qty = Math.max(1, Math.min(10, parseInt(d.quantity, 10) || 1));
      window.dispatchEvent(new CustomEvent('polly:add_to_cart', { detail: {
        variant_id: vid, quantity: qty, request_id: rid,
        respond: function (r) { cartResult(rid, r); } } }));
    }
  }

  // The theme may also answer by event instead of detail.respond().
  window.addEventListener('polly:cart_result', function (e) {
    var d = e.detail || {};
    var rid = String(d.request_id || '') || Object.keys(pending)[0];
    if (rid) cartResult(rid, d);
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && isOpen) close(); });
  btn.addEventListener('click', toggle);

  function mount() { document.body.appendChild(btn); }
  if (document.body) mount(); else document.addEventListener('DOMContentLoaded', mount);
  window.Polly = { open: open, close: close, toggle: toggle };
})();
